<script>
	// Using rollup in VS Code to create a deployable build: https://typeofnan.dev/how-to-set-up-a-svelte-app-with-rollup/
	// Bundling CSS files: https://carlosroso.com/how-to-import-css-files-to-svelte/
	import Map from "./Map.svelte";
	import SignIn from "./SignIn.svelte";
	import dbData from "./Stores/utilityDBStore.js"
	import { fetchCurrentAuthToken, formRequestAction, signOutCognitoUser } from "./scripts/awsUtils.js";
    import { resetMapManager } from "./scripts/viewMap.js";

	let isSignedIn = false;
	let hasMapLoaded = false;
	let wpnID;
    let loginEmail;

	function didSignIn(event) {
		wpnID = event.detail.wpnID;
        loginEmail = event.detail.loginEmail;
        console.log("Signing in with WPN ID: ", wpnID);
        dbData.setWPNID(wpnID);
        dbData.setLoginEmail(loginEmail);
        isSignedIn = true;
	}

	function willSignOut() {
		if ($dbData.modifications.updated.length > 0) {
            try {
                let promise = new Promise(fetchCurrentAuthToken);
                promise.then((value) => sendModifiedDataFromApp(value));
            } catch (error) {
                alert("An error has occurred, please check internet connection and try again.");
                console.log(error);
            }
        }
        wpnID = $dbData.wpn_id;
        resetMapManager();
        dbData.setDatabase([]);
        dbData.setUtility(null);
        dbData.setLoginEmail("");
        dbData.setUser(null);
        dbData.clearAllALFXData();
		isSignedIn = false;
		signOutCognitoUser();
	}

	async function sendModifiedDataFromApp(authToken) {
        try {
            const updatedItems = $dbData.modifications.updated ?? [];
            const ra = formRequestAction("modify", {wpn_id: $dbData.wpn_id, items: updatedItems}, authToken);
            const resModify = await fetch(ra.url, ra.initData);
            const wasSent = (resModify.ok && resModify.status < 300);
            const msg = (wasSent) ? 'Success: Server upupdated' : 'Error: Failed to update server';
            console.log(msg);
        } catch (error) {
            console.error('Error sending Modify request: ', error);
        }
        return;
    }

    // async function attemptReadingSeed() {
    //     try {
    //         let promise = new Promise(fetchCurrentAuthToken);
    //         promise.then((value) => getUtilitySeed(value));
    //     } catch (error) {
    //         console.log(error);
    //     }
    // }

    // async function getUtilitySeed(authToken) {
    //     try {
    //         const ra = formRequestAction("read_seed", {wpn_id: wpnID}, authToken);
    //         const resSeed = await fetch(ra.url, ra.initData);
    //         if (resSeed.ok) {
    //             const wpnIDDict = await resSeed.json();
    //             const wpnID = wpnIDDict['wpn_id'];
    //             console.log("Signing in to Seed: ", wpnID);
    //             if (wpnID != undefined) {
    //                 dbData.setWPNID(wpnID);
    //                 // dbData.setUtility(utility);
    //                 dbData.emptyUpdatesStore();
    //                 isSignedIn = true;
    //             }
    //             // const utility = await resSeed.json();
    //             // console.log("Signing in to Seed: ", utility);
    //             // if (utility != undefined) {
    //             //     wpnID = utility.wpn_id;
    //             //     dbData.setWPNID(wpnID);
    //             //     dbData.setUtility(utility);
    //             //     dbData.emptyUpdatesStore();
    //             //     isSignedIn = true;
    //             // }
    //         }
    //     } catch (err) {
    //         console.log(err);
    //     }
    // }

</script>

<svelte:head>
	<script
		defer
		async
		src="https://cdn.apple-mapkit.com/mk/5.x.x/mapkit.js"></script>
</svelte:head>

{#if isSignedIn}
    <Map
        {hasMapLoaded}
        on:sign-out={willSignOut}
        on:map-loaded={() => (hasMapLoaded = true)}
    />
{:else}
    <SignIn 
        {wpnID}
        on:signed-in={didSignIn}
    />
{/if}

<style>
	:global(body) {
		padding: 0;
	}
</style>
